import { Box, Button, Grid, TextField } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../../App";
import EstoqueParceiro from "../../components/classes/EstoqueParceiro";
import AutocompleteCentroEstoque from "../../components/common/AutocompleteCentroEstoque";
import AutocompleteSKUEstoque from "../../components/common/AutocompleteSkuEstoque";
import EstoqueParceiroDataset from "../../components/data/EstoqueParceiroDataset";
import PropriedadeParceiroDataset from "../../components/data/PropriedadeParceiroDataSet";
import Utils from "../../helper/utils";

import { useTranslation } from "react-i18next";

export default function NovoEstoqueParceiroFragment(props: any) {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(true);

  const [quantidadeFieldValidation, setQuantidadeFieldValidation] = useState<{
    hasError: boolean;
    errorMessage: string;
  }>({
    hasError: false,
    errorMessage: "",
  });

  const [unidadeMedidaFieldValidation, setUnidadeMedidaFieldValidation] =
    useState<{
      hasError: boolean;
      errorMessage: string;
    }>({
      hasError: false,
      errorMessage: "",
    });

  const [id, setId] = useState<string>("");
  const [material, setMaterial] = useState<string>("");
  const [quantidade, setQuantidade] = useState<string>("");
  const [unidadeMedida, setUnidadeMedida] = useState<string>("");

  const estoqueEmbalagensDataset: EstoqueParceiroDataset =
    new EstoqueParceiroDataset();
  const propriedadeParceiroDataset: PropriedadeParceiroDataset =
    new PropriedadeParceiroDataset();

  useEffect(() => {
    if (props.estoqueParceiro) {
      setId(props.estoqueParceiro.id);
      setMaterial(props.estoqueParceiro.material);
      setQuantidade(
        Utils.maskNumberToSAPDecimal(
          parseFloat(props.estoqueParceiro.quantidade).toFixed(3)
        )
      );
      setUnidadeMedida(props.estoqueParceiro.unidadeMedida);
      setIsUpdate(true);
    }
  }, []);

  function validate(): boolean {
    let isValid: boolean = true;

    // if (!material || material.length < 1) {
    //   isValid = false;
    // }

    if (!quantidade || quantidade.toString().length < 1) {
      isValid = false;
      setQuantidadeFieldValidation({
        hasError: true,
        errorMessage: t("pages.stockPartnerNamed.text.thisFieldCannotBeEmpty"),
      });
    } else {
      setQuantidadeFieldValidation({
        hasError: false,
        errorMessage: "",
      });
    }

    // if (!unidadeMedida || unidadeMedida.length < 1) {
    //   isValid = false;
    //   setUnidadeMedidaFieldValidation({
    //     hasError: true,
    //     errorMessage: t("pages.stockPartnerNamed.text.thisFieldCannotBeEmpty"),
    //   });
    // } else {
    //   if (unidadeMedida.length > 5) {
    //     isValid = false;
    //     setUnidadeMedidaFieldValidation({
    //       hasError: true,
    //       errorMessage: t("pages.stockPartnerNamed.text.thisFieldCannotBeLonger"),
    //     });
    //   } else {
    //     setUnidadeMedidaFieldValidation({
    //       hasError: false,
    //       errorMessage: "",
    //     });
    //   }
    // }

    if (!isValid) {
      setHasError(true);
    } else {
      setHasError(false);
    }

    return isValid;
  }

  async function onSubmitHandler(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    e.preventDefault();
    if (validate()) {
      if (isUpdate) {
        let centroIndustrializacao =
          await propriedadeParceiroDataset.getCentroIndustrializacao(
            props.parceiro.codigoFornecedorSAP.valueOf()
          );
        const estoqueEmbalagem: EstoqueParceiro = new EstoqueParceiro(
          parseInt(id),
          centroIndustrializacao,
          material,
          parseFloat(quantidade.replaceAll(".", "").replaceAll(",", ".")),
          unidadeMedida
        );
        estoqueEmbalagensDataset.update(estoqueEmbalagem).then((e) => {
          props.onSubmit();
        });
      } else {
        const estoqueEmbalagem: EstoqueParceiro = new EstoqueParceiro(
          0,
          props.centro,
          material,
          parseFloat(quantidade),
          unidadeMedida
        );
        estoqueEmbalagensDataset.add(estoqueEmbalagem).then((e) => {
          props.onSubmit();
        });
      }
    }
  }

  return (
    <form>
      <div>
        <div>
          <Box
            margin={"12px"}
            padding={"24px"}
            sx={{
              display: "flex",
              width: "100%",
              "align-items": "center",
            }}
          >
            {/* <Box width={240} margin={"12px"}>
              <AutocompleteSKUEstoque
                value={props.estoqueParceiro?.material.toString()}
                onChange={(sku: any) => {
                  setMaterial(sku);
                  validate();
                }}
              />
            </Box> */}

            <Box width={240} margin={"12px"}>
              <TextField
                required
                error={quantidadeFieldValidation.hasError}
                helperText={quantidadeFieldValidation.errorMessage}
                label={t("common.quantity")}
                variant="outlined"
                value={quantidade}
                onChange={(e) =>
                  setQuantidade(Utils.maskNumberToSAPDecimal(e.target.value))
                }
                onBlur={(e) => {
                  validate();
                }}
              />
            </Box>

            {/* <Box width={240} margin={"12px"}>
              <TextField
                required
                error={unidadeMedidaFieldValidation.hasError}
                helperText={unidadeMedidaFieldValidation.errorMessage}
                label="Unidade de Medida"
                variant="outlined"
                value={unidadeMedida}
                onChange={(e) => setUnidadeMedida(e.target.value)}
                onBlur={(e) => {
                  validate();
                }}
              />
            </Box> */}

            <Box>
              {isUpdate ? (
                <Button
                  disabled={hasError || user.isSuporte}
                  type="submit"
                  variant="outlined"
                  color="success"
                  onClick={onSubmitHandler}
                >
                  {t("common.save")}
                </Button>
              ) : (
                <Button
                  disabled={hasError || user.isSuporte}
                  type="submit"
                  variant="outlined"
                  color="success"
                  onClick={onSubmitHandler}
                >
                  {t("common.add")}
                </Button>
              )}
            </Box>
          </Box>
        </div>
      </div>
    </form>
  );
}
